import React from 'react'
import classnames from 'classnames';
import { connect } from 'react-redux';
import '@/assets/styles/components/watchlist.scss';
import { getClassnameColorByValue, getElementWidthHeightById } from '@/helpers/global';
import { mobileSubLayoutAction } from '@/actions/app/mobileSubLayout.action';
import { getSafeStorage } from '@/helpers/global';
import { STORAGE_KEY as storageKey } from '@/constants/storage.key';
import { userActions } from '@/actions/user';
import { stockActions } from '@/actions/trading/stock.action';
import { ACTION_TYPE } from "@/constants/w-socket";
import { utilsFunction, Converter,accessibilityFunctions, keyDownFunctions } from "@/helpers/functions";
import LoadingLayer from '@/components/Spinner/LoadingLayer';
import { WS_LANG_KEY, REFRESH_DATA } from '@/constants/app';
import BackIcon from '@/assets/images/icons/quote_icon_back.png';
import {WATCHLIST_FILTER_TYPE} from '@/constants/filter-type'
import { SERVICES_RESP , history} from '@/configurations';

class WatchlistMinimize extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rowData: [],
      selectedTab: 1,
      load: false,
      subTablist :[
      {
        id: 1, title: 'market_all', value:''
      },
      {
        id: 2, title: 'market_hkex', value:'HKEX'
      },
      {
        id: 3, title: 'market_usex', value:'USEX'
      },
      {
        id: 4, title: 'market_stock_connect', value:'CN'
      },
      ],
      subTab:{id: 1, title: 'market_all', value:''}
    }
    if(props.innerRef){
      props.innerRef(this)
    }
  }
  getWatchLists(market = 'ALL') {
    const {mdsToken} = this.props
    const { id } = this.props.userInfo
    this.setState({
      load: true,
      rowData:null
    })
    this.setState({ rowData: [] })
    let watchlistdata = []
    this.props.getWatchlist({ uuid: id }, res => {
      if (Array.isArray(res.result) && res.result.length) {
        const lang = this.props.language.lang
        let filted = res.result.filter(item => item.name == WATCHLIST_FILTER_TYPE.All)[0].flaggings
        const sample = ['symbol', 'stockName', 'price', 'change', 'bid', 'ask', 'volume', 'turnoverRate', 'open', 'close', 'high', 'low', 'turnover', 'marketv', 'floatc', 'shares', 'ttmeps'].reduce((prev, next) => (prev[next] = '-', prev), {})
        if (market === 'HKEX') {
          filted = res.result.filter((item)=>  item.name == WATCHLIST_FILTER_TYPE.HK)[0].flaggings
        } else if(market === 'USEX'){
          filted  = res.result.filter((item)=>  item.name == WATCHLIST_FILTER_TYPE.US)[0].flaggings
        }else if(market == 'CN'){
          filted  = res.result.filter((item)=>  item.name == WATCHLIST_FILTER_TYPE.StockConnect)[0].flaggings
        }
        if (filted) {
          for (let i = 0; i < filted.length; i++) {
            let watchlistData = {
              marketID: filted[i].market,
              stockCode: filted[i].id,
              stockChineseShortName: filted[i].name,
              stockName: filted[i].name
            }
            watchlistdata.push(watchlistData)
          }
        }
        const rowData = []
        for (let i = 0; i < watchlistdata.length; i++) {
          const item = watchlistdata[i]
          const deepSample = JSON.parse(JSON.stringify(sample))
          deepSample.symbol = [item.marketID, item.stockCode].join('.')
          let stockID = item.stockCode.split('').findIndex(i => i !== '0')
          if (stockID > -1) stockID = item.stockCode.substr(stockID)
          const marketID = Converter.mappingWebSocketMarket(item.marketID)
          if (lang === 'zh_TW' || lang === 'zh_CN') {
            deepSample.stockName = item.stockChineseShortName
            if(!item.stockChineseShortName){
              deepSample.stockName = item.stockName
            }
          } else {
            deepSample.stockName = item.stockName
          }
          // const dparams = { instrumentID: item.id, exchangeID: item.market }
          if (marketID === 'XNYS') {
            const params = { symbols: [{ exchangeID: marketID, key: stockID }] }
            stockActions.getBestBidBestAskAction(params, bestBidBestAskRes => {
              const oneNewRowData = JSON.parse(JSON.stringify(this.state.rowData))
              const deepSample = oneNewRowData?.[i]
              if (deepSample) {
                deepSample.bid = Array.isArray(bestBidBestAskRes.bestBid) ? bestBidBestAskRes.bestBid?.[0]?.price : bestBidBestAskRes.bestBid?.price
                deepSample.ask = Array.isArray(bestBidBestAskRes.bestAsk) ? bestBidBestAskRes.bestAsk?.[0]?.price : bestBidBestAskRes.bestAsk?.price 
                this.setState({ rowData: oneNewRowData })
              }
            })
            stockActions.getStatisticsAction(params, statisticsRes => {
              const twoNewRowData = JSON.parse(JSON.stringify(this.state.rowData))
              const deepSample = twoNewRowData?.[i]
              if (deepSample) {
                deepSample.currentPrice = statisticsRes.last
                deepSample.open = statisticsRes.open
                deepSample.high = statisticsRes.high
                deepSample.low = statisticsRes.low
                deepSample.volume = statisticsRes.volume
                deepSample.turnover = statisticsRes.turnover
                stockActions.getClosingPriceAction(params, closingPriceRes => {
                  const threeNewRowData = JSON.parse(JSON.stringify(this.state.rowData))
                  const deepSample = threeNewRowData?.[i]
                  if (deepSample) {
                    deepSample.prevclose = closingPriceRes.closingPrice
                    deepSample.changeValue = `${utilsFunction.datatableCurrencyFormatter(statisticsRes.last - closingPriceRes.closingPrice)}`
                    deepSample.changePercent = `(${utilsFunction.datatableFormatPercent((statisticsRes.last - closingPriceRes.closingPrice) / closingPriceRes.closingPrice * 100)})`
                    this.setState({ rowData: threeNewRowData })
                  }
                })
                this.setState({ rowData: twoNewRowData })
              }
            })
          } else {
            const dparams = {
              symbols: [
                {
                  exchangeID: marketID,
                  key: stockID
                }
              ],
              sessID: mdsToken
            }
            const params = {
              msgType: ACTION_TYPE.SECURITY_FINANCIAL_DATA,
              symbol: { exchangeID: marketID, key: stockID },
              language: utilsFunction.switchToolTipsLanguage(this.props.language, WS_LANG_KEY.EN, WS_LANG_KEY.SC, WS_LANG_KEY.TC)
            }
            this.props.getFinancial(params, financialres => {
              if (financialres && Object.keys(financialres).length) {
                const oneNewRowData = JSON.parse(JSON.stringify(this.state.rowData))
                const deepSample = oneNewRowData[i]
                if (deepSample) {
                  Object?.assign(deepSample, { shares: financialres.totalCapital, marketv: financialres.marketCap, ttmeps: financialres.earnps })
                  this.props.getDetailPriceInfo(dparams, quetores => {
                    if (quetores && Object.keys(quetores).length) {
                      const twoNewRowData = JSON.parse(JSON.stringify(this.state.rowData))
                      const deepSample = twoNewRowData[i]
    
                      deepSample.currentPrice = quetores.last
                      deepSample.bid = quetores.bids?.[0]?.price
                      deepSample.ask = quetores.asks?.[0]?.price
                      deepSample.turnoverRate = quetores.turnoverRate ? quetores.turnoverRate : '-'
                      deepSample.open = quetores.open
                      deepSample.high = quetores.high
                      deepSample.low = quetores.low
                      deepSample.volume = quetores.vol
                      deepSample.close = quetores.prev
                      deepSample.turnover = quetores.turnover
                      deepSample.changeValue = utilsFunction.datatableCurrencyFormatter(quetores.last - quetores.prev)
                      deepSample.changePercent = `(${utilsFunction.datatableFormatPercent((quetores.last - quetores.prev) / quetores.prev * 100)})`
                      // if (lang === 'zh_TW') {
                      //   deepSample.stockName = quetores.tcName
                      // } else if (lang === 'zh_CN') {
                      //   deepSample.stockName = quetores.scName
                      // } else {
                      //   deepSample.stockName = quetores.name
                      // }
                      this.setState({ rowData: twoNewRowData })
                    }
                  })
    
                  this.setState({ rowData: oneNewRowData })
                }
              }
            })
          }
          rowData.push(deepSample)
        }
        this.setState({ rowData: rowData , load:false})
      }
    })  
  }

  getQuoteHistory() {
    const { load } = this.state;
    const {mdsToken} = this.props
    this.setState({
      load: true,
      rowData: null
    })
    const { id } = this.props.userInfo
    this.props.getQuoteHistory({uuid : id}, res => {
      if (res.instrument.length === 0) {
        this.setState({
          rowData: [],
          load: false
        })
      } else {
        const lang = this.props.language.lang
        const sample = ['symbol', 'stockName', 'price', 'change', 'volume', 'turnover', 'turnoverRate', 'open', 'prev', 'high', 'low', 'marketv', 'shares', 'lyr'].reduce((prev, next) => (prev[next] = '-', prev), {})
        const filted = res.instrument
        const rowData = []
        for (let i = 0; i < filted.length; i++) {
            const data = filted[i].split(':')
            const item = {
              marketID : data[1],
              id : data[0],
              name : data[2],
            }
            
            const deepSample = JSON.parse(JSON.stringify(sample))
            deepSample.symbol = [item.marketID, item.id].join('.')
            let stockID = item.id.split('').findIndex(i => i !== '0')
            if (stockID > -1) stockID = item.id.substr(stockID)
            const marketID = Converter.mappingWebSocketMarket(item.marketID)
            deepSample.stockName = item.name
            if (marketID === 'XNYS') {
              const params = { symbols: [{ exchangeID: marketID, key: stockID }] }
              stockActions.getBestBidBestAskAction(params, bestBidBestAskRes => {
                const oneNewRowData = JSON.parse(JSON.stringify(this.state.rowData))
                const deepSample = oneNewRowData?.[i]
                if (deepSample) {
                  deepSample.bid = Array.isArray(bestBidBestAskRes.bestBid) ? bestBidBestAskRes.bestBid?.[0]?.price : bestBidBestAskRes.bestBid?.price
                  deepSample.ask = Array.isArray(bestBidBestAskRes.bestAsk) ? bestBidBestAskRes.bestAsk?.[0]?.price : bestBidBestAskRes.bestAsk?.price 
                  this.setState({ rowData: oneNewRowData })
                }
              })
              stockActions.getStatisticsAction(params, statisticsRes => {
                const twoNewRowData = JSON.parse(JSON.stringify(this.state.rowData))
                const deepSample = twoNewRowData?.[i]
                if (deepSample) {
                  deepSample.currentPrice = statisticsRes.last
                  deepSample.open = statisticsRes.open
                  deepSample.high = statisticsRes.high
                  deepSample.low = statisticsRes.low
                  deepSample.volume = statisticsRes.volume
                  deepSample.turnover = statisticsRes.turnover
                  stockActions.getClosingPriceAction(params, closingPriceRes => {
                    const threeNewRowData = JSON.parse(JSON.stringify(this.state.rowData))
                    const deepSample = threeNewRowData?.[i]
                    if (deepSample) {
                      deepSample.prevclose = closingPriceRes.closingPrice
                      deepSample.changeValue = `${utilsFunction.datatableCurrencyFormatter(statisticsRes.last - closingPriceRes.closingPrice)}`
                      deepSample.changePercent = `(${utilsFunction.datatableFormatPercent((statisticsRes.last - closingPriceRes.closingPrice) / closingPriceRes.closingPrice * 100)})`
                      this.setState({ rowData: threeNewRowData })
                    }
                  })
                  this.setState({ rowData: twoNewRowData })
                }
              })
            } else {
              const dparams = {
                symbols: [
                  {
                    exchangeID: marketID,
                    key: stockID
                  }
                ],
                sessID:mdsToken
              }
              const params = {
                msgType: ACTION_TYPE.SECURITY_FINANCIAL_DATA,
                symbol: { exchangeID: marketID, key: stockID },
                language: utilsFunction.switchToolTipsLanguage(this.props.language, WS_LANG_KEY.EN, WS_LANG_KEY.SC, WS_LANG_KEY.TC)
              }
  
              this.props.getFinancial(params, financialres => {
                if (financialres) {
                  const oneNewRowData = JSON.parse(JSON.stringify(this.state.rowData))
                  const deepSample = oneNewRowData?.[i]
                  if (deepSample) {
                    Object.assign(deepSample, { shares: financialres.totalCapital, lyr: financialres.earnps, marketv: financialres.marketCap })
                    this.props.getDetailPriceInfo(dparams, quetores => {
                      if (quetores) {
                        const twoNewRowData = JSON.parse(JSON.stringify(this.state.rowData))
                        const deepSample = twoNewRowData?.[i]
                        if (deepSample) {
                          deepSample.currentPrice = quetores.last
                          deepSample.turnoverRate = quetores.turnoverRate ? quetores.turnoverRate : '-'
                          deepSample.open = quetores.open
                          deepSample.high = quetores.high
                          deepSample.low = quetores.low
                          deepSample.volume = quetores.vol
                          deepSample.prev = quetores.prev
                          deepSample.turnover = quetores.turnover
                          deepSample.changeValue = utilsFunction.datatableCurrencyFormatter(quetores.last - quetores.prev)
                          deepSample.changePercent = `(${utilsFunction.datatableFormatPercent((quetores.last - quetores.prev) / quetores.prev * 100)})`
                          
                          this.setState({ rowData: twoNewRowData })
                        }
                      }
                    })
                    this.setState({ rowData: oneNewRowData })
                  }
  

                }
              })
            }
            rowData.push(deepSample)
          }
          
          this.setState({ rowData: rowData })
        }
       this.setState({ load: false })
    })
  }

  changeSubTab=(item,market)=>{
    this.setState({subTab : item})
    this.getWatchLists(market)
  }

  componentDidMount() {
    const { id } = this.props.userInfo
    if(id){
      const { location } = history
      if(location.state.currentSelect){
        this.changeSubTab(location.state.currentSelect,location.state.currentSelect.value)
      }else {
        this.getWatchLists()
      }
    }
    // this.setState({
    //   load: true
    // })
    setTimeout(() => {
      const wh = getElementWidthHeightById("watchlist-minimize");
      this.props.onWatchlistMinimizeRendered(wh);
    }, 600);
  }

  componentDidUpdate(preProps, preState) {
    const { isNeedRefresh , language } = this.props;
    if (this.props.userInfo && preProps.userInfo !== this.props.userInfo) {
      if (this.state.selectedTab === 1) {
        this.getWatchLists()
      } else if (this.state.selectedTab === 2) {
        this.getQuoteHistory()
      }
    }
    if (this.state.selectedTab && preState.selectedTab !== this.state.selectedTab) {
      if (this.state.selectedTab === 1) {
        this.getWatchLists()
      } else if (this.state.selectedTab === 2) {
        this.getQuoteHistory()
      }
    }
    if (isNeedRefresh && preProps.isNeedRefresh !== isNeedRefresh) {
      if(this.state.selectedTab === 2) {
        return
      }
      this.getWatchLists(this.state.subTab.value)
      // this.props.toggleRefreshMarket(false)
    }
    if (language && preProps.language !== language) {
      if (this.state.selectedTab === 1) {
        this.getWatchLists()
      } else if (this.state.selectedTab === 2) {
        this.getQuoteHistory()
      }
    }
  }

  componentWillUnmount() {
    this.setState = () => {}
  }

  render() {
    const { language, isMobile } = this.props;
    const { rowData, selectedTab, load ,subTab ,subTablist} = this.state;
	
    return (
      <div id="watchlist-minimize" className={classnames("watchlist-minimize-container", 'watchlist-minimize-container-ttl')}>
        {!isMobile && <div className="tab-header">
		  <div onClick={() => this.props.onClose()}  className='tab-header-back' 
          onKeyDown={keyDownFunctions.handleEnterKeyDown(() => this.props.onClose())}
          {...accessibilityFunctions.hasTabIndex()}
      >
		    <img src={BackIcon} alt='close_icon' /> {language.common_back}
		  </div>
		  <div  className='select-block' >
			  <div className={classnames("tab-header-item", selectedTab === 1 && 'tab-header-item-active')}
				onClick={() => selectedTab === 2 && this.setState({ selectedTab: 1 })}
        onKeyDown={keyDownFunctions.handleEnterKeyDown(() => selectedTab === 2 && this.setState({ selectedTab: 1 }))}
        {...accessibilityFunctions.hasTabIndex()}>
				{language.watchlist_title}
			  </div>
			  <div className={classnames("tab-header-item", selectedTab === 2 && 'tab-header-item-active')}
				onClick={() => selectedTab === 1 && this.setState({ selectedTab: 2 })}
        onKeyDown={keyDownFunctions.handleEnterKeyDown(() => selectedTab === 1 && this.setState({ selectedTab: 2 }))}
        {...accessibilityFunctions.hasTabIndex()}>
				{language.common_recent}
			  </div>
		  </div>
        </div>}
        {selectedTab === 1 && <div className='sub-header'>
         {subTablist.map(item => 
            <div key={item.id} className={classnames("sub-header-item", subTab.id === item.id && 'sub-header-item-active')}
              onClick={() => this.changeSubTab(item,item.value)}
              onKeyDown={keyDownFunctions.handleEnterKeyDown(() => this.changeSubTab(item,item.value))}
              {...accessibilityFunctions.hasTabIndex()}>
              {language[item.title]}
            </div>)}
        </div>
        }
        <div className="tab-content">
          <LoadingLayer load={load} />

          {rowData?.map(item =>
            <div key={item.symbol} className="tab-content-item" onClick={() => this.handleOpenStockDetail( item.symbol )}
                 onKeyDown={keyDownFunctions.handleEnterKeyDown(() => this.handleOpenStockDetail( item.symbol ))} {...accessibilityFunctions.hasTabIndex()}>
              <div className="stock-infor">
                <div className="stock-name">{item.stockName}</div>
                <div className="stock-code">{item.symbol}</div>
              </div>
              <div className={classnames("stock-price", getClassnameColorByValue(item.changeValue))}>
                <div className="current-price">{item.currentPrice}</div>
                <div className={"change-value"}>
                  <span className={classnames("number", this.getChangeValueBackground(item.changeValue))}>
                    {item.changeValue}
                  </span>
                  <span className="percent">{item.changePercent}</span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }

  handleOpenStockDetail(stock) {
    const marketID = stock.substring(0, stock.indexOf("."))
    let marketList = []
    this.props.markets.map(item=>{
      marketList.push(item.value)
    })
    if(!marketList.includes(marketID)){
      return
    }
    if (marketID === 'USEX') {
      const stockID = stock?.split('.')?.[1]
      this.props.setStock({ stockCode: stockID, marketID }, () => {
        this.props.changeMarket(marketID, this.props.tradeDateInfoList, this.props.tradeConfigSettings)
      })
    } else {
      let stockID = stock.substring(stock.indexOf(".") + 1).split('').findIndex(i => i !== '0')
      if (stockID > -1) {
        stockID = stock.substring(stock.indexOf(".") + 1).substr(stockID)
      }
      this.props.setStock({ stockCode: stockID, marketID: Converter.mappingWebSocketMarket(stock.substring(0, stock.indexOf("."))) })
      this.props.changeMarket(stock.substring(0, stock.indexOf(".")), this.props.tradeDateInfoList, this.props.tradeConfigSettings)
    }
  }

  getChangeValueBackground(value) {
    if (this.props.isMobile) {
      if (parseFloat(value) === 0) {
        return ''
      }
      return parseFloat(value) > 0 ? 'green-background' : 'red-background';
    }
  }
}

export default connect(
  state => ({
    language: state.app.language,
    isMobile: state.app.isMobile,
    userInfo: state.user.userInfo,
    isNeedRefresh: state.refresh.marketAction,
    language: state.app.language,
    mdsToken: state.trade.mdsToken,
    tradeDateInfoList: state.trade.tradeDateInfoList,
    markets: [{ label: state.app.language.market_all, value: '' }, ...state.trade.markets],
    tradeConfigSettings: state.trade.tradeConfigSettings
  }),
  dispatch => ({
    getWatchlist: (p, c) => dispatch(userActions.getInstrumentWatchlistAction(p, c)),
    getQuoteHistory: (p, c) => dispatch(userActions.getQuoteHistoryAction(p, c)),
    getDetailPriceInfo: (p, c) => dispatch(stockActions.getDetailPriceInfoAction(p, c)),
    getFinancial: (p, c) => stockActions.getFinancialAction(p, c),
    changeMarket: (p, p2, res) => dispatch(stockActions.changeMarketAction(p, p2, res)),
    setStock: (p, res) => dispatch(stockActions.setMarketStockAction(p, res)),
    toggleRefreshMarket: (p) => {
      dispatch({
        type: REFRESH_DATA.MARKET_ACTION,
        value: p
      })
    }
  })
)(WatchlistMinimize)
